var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ch1 class=\"page-title text-center\"\u003E{{ \"FTU.GETTING_STARTED\" | translate }}\u003C\u002Fh1\u003E\u003Coz-coming-soon\u003E\u003C\u002Foz-coming-soon\u003E";;return pug_html;};
module.exports = template;